import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import PhotoGallery from './components/PhotoGallery';
import PhotoBook from './components/PhotoBook';
import AdminLayout from './components/admin/AdminLayout';
import AdminPhotoList from './components/admin/AdminPhotoList';
import PhotoUploadForm from './components/admin/PhotoUploadForm';
import PhotoEditForm from './components/admin/PhotoEditForm';
import AdminLogin from './components/admin/AdminLogin';
import ProtectedRoute from './components/admin/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { initializeImageProtection } from './utils/imageProtection';
import './App.css';

// Component to manage image protection based on route
function ImageProtectionWrapper({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    // Only enable image protection on public routes
    if (!isAdminRoute) {
      const cleanup = initializeImageProtection();
      return cleanup;
    }
  }, [isAdminRoute]);

  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ImageProtectionWrapper>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/gallery" element={<PhotoGallery />} />
            <Route path="/book" element={<PhotoBook />} />
            <Route path="/book/:index" element={<PhotoBook />} />

            {/* Admin Login */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Protected Admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminPhotoList />} />
              <Route path="upload" element={<PhotoUploadForm />} />
              <Route path="edit/:id" element={<PhotoEditForm />} />
            </Route>
          </Routes>
        </ImageProtectionWrapper>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
